/**
 * Placeholder asset — the safe substitute for a missing/broken asset reference. A
 * stable inline transparent SVG so an unresolved reference never emits a broken image.
 */
import type { ResolvedAsset } from '../types'

/** A 1×1 transparent SVG data URI (deterministic, no network). */
export const PLACEHOLDER_URL =
  "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='1' height='1'></svg>"

/** Build a placeholder ResolvedAsset for a missing id. */
export function placeholderAsset(id: string): ResolvedAsset {
  return { id, type: 'image', url: PLACEHOLDER_URL, isPlaceholder: true }
}
